import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { useAssessmentSaveAndExit } from "../../providers/AssessmentSaveAndExitProvider";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory } from "react-router-dom";
import { usePatient } from "../../providers/PatientProvider";
import { useAssessment } from "../../providers/AssessmentProvider";
import { useAssessmentTabs } from "../../providers/AssessmentTabsProvider";

const style = {
  position: "absolute",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  padding: "16px 24px",
};

export default function TransitionsModal() {
  const history = useHistory();
  const { patientData } = usePatient();
  let { showSaveAndExitModal, toggleSaveAndExitModal } =
    useAssessmentSaveAndExit();
  const { saveAssessmentData } = useAssessment();
  const { selectedTab } = useAssessmentTabs();

  const handleSaveAndExitButtonClick = async () => {
    let status = selectedTab === 3 ? selectedTab : selectedTab + 1;
    await saveAssessmentData(status);
    toggleSaveAndExitModal();
    history.push({
      pathname: `/patients/${patientData.patientId}/1`,
    });
  };
  return (
    <Modal
      className="FSUnmask"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showSaveAndExitModal}
      onClose={toggleSaveAndExitModal}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={showSaveAndExitModal}>
        <Box
          sx={{
            ...style,
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", marginBottom: "8px" }}
          >
            <Typography
              id="transition-modal-title"
              variant="p"
              fontSize={24}
              style={{ marginRight: "100px" }}
            >
              Are you sure you want to leave?
            </Typography>
            <div onClick={toggleSaveAndExitModal} style={{ cursor: "pointer" }}>
              <CloseIcon />
            </div>
          </Box>
          <Typography
            id="transition-modal-description"
            sx={{ color: "#546E7A" }}
            variant="p"
            fontSize={16}
          >
            Your progress will be saved for 24 hours.
          </Typography>
          <Box sx={{ marginTop: "15px", textAlign: "right" }}>
            <Button
              variant="outlined"
              sx={{
                padding: "6px 16px",
                marginRight: "10px",
                borderColor: "#09306d",
                color: "#09306d",
              }}
              onClick={toggleSaveAndExitModal}
            >
              Stay
            </Button>
            <Button
              variant="contained"
              sx={{
                padding: "6px 16px",
                backgroundColor: "#0D47A1",
                color: "white",
              }}
              onClick={handleSaveAndExitButtonClick}
            >
              Save & Exit
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}
